module.exports = __webpack_public_path__ + "static/img/googlePlay.7c36c0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/footer/googlePlay.svg
// module id = 1819
// module chunks = 1